module.exports = __webpack_public_path__ + "static/concerns-841643a3382f3a974aa1e8e5e3574c0e.jpg";